export const workbenchKeys = {
  workItems: {
    all: ["workItems"] as const,
    lists: () => [...workbenchKeys.workItems.all, "list"] as const,
    list: (filters: Record<string, unknown>) =>
      [...workbenchKeys.workItems.lists(), filters] as const,
    details: () => [...workbenchKeys.workItems.all, "detail"] as const,
    detail: (id: string) =>
      [...workbenchKeys.workItems.details(), id] as const,
  },
  stats: {
    all: ["queueStats"] as const,
  },
  lifecycles: {
    all: ["lifecycles"] as const,
    detail: (type: string) =>
      [...workbenchKeys.lifecycles.all, type] as const,
  },
  dashboard: {
    all: ["dashboard"] as const,
    personal: (userId: string) => ["dashboard", "personal", userId] as const,
    team: (teamId: string, range: string) => ["dashboard", "team", teamId, range] as const,
    workers: (teamId: string, range: string) => ["dashboard", "workers", teamId, range] as const,
  },
} as const;
